export default __webpack_public_path__ + "ff11f352c0d8992f508682c19e13b320.png";